import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OnPrem, ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { Observable } from 'rxjs';
import {
    GetOption,
    HateoasResourceOperation,
    PagedGetOption,
    HttpMethod,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import {  HTTP_CLIENT} from '@netfoundry-ui/shared/services';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OnPremService extends HateoasResourceOperation<OnPrem> {
    static defaultPaginationSize = 500;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };
    lastPageCount = 0;
    lastTotalCount = 0;
    apiUrl: string;

    constructor(
        @Inject(HTTP_CLIENT) private http: HttpClient, 
        @Inject(ENVIRONMENT) private environment: Environment)
        {
        super(OnPrem);
        this.apiUrl = this.environment.customerURL;
    }


    async getExternalAccountPage(options?: PagedGetOption, includeProperties?: string): Promise<OnPrem[]> {
        let params = { ...OnPremService.defaultHttpAccept, ...options };
        if (includeProperties) {
            params = { ...params, headers: { accept: `application/hal+json;includeProperties=${includeProperties}` } };
        }
        return super
            .getPage(params)
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((accounts) => (accounts ? accounts.resources : ([] as OnPrem[])));
    }

  public findExternalAccount(externalAccountId: string) {
        const fullpath = `${this.apiUrl}external-accounts/${externalAccountId}`;
            //       const headers = new HttpHeaders({
            //     'Accept': 'application/yaml;'
            // });
        return this.http
            .get(fullpath)
    }

      public findExternalAccountKubernetes(externalAccountId: string) {
        const fullpath = `${this.apiUrl}external-accounts/${externalAccountId}`;
          const headers = new HttpHeaders({
                'Accept': 'application/yaml;as=kubernetes'
            });
        return this.http
            .get(fullpath, {headers})
    }





}